import { getWalletClient } from '../wallet';

import { AmountWithCurrencyObjectType, MonthlyProfitQuery } from './__generated__/sdk';
import { getCoreClient } from './client';

export interface GetMonthlyProfitProps {
  page?: number;
  perPage: number;
}

export async function getMonthlyProfit({ page = 0, perPage }: GetMonthlyProfitProps): Promise<MonthlyProfitQuery> {
  const walletClient = await getWalletClient();
  const coreClient = await getCoreClient();
  if (!coreClient.enabled) {
    return walletClient.MonthlyProfit({ page, perPage });
  }
  return coreClient.MonthlyProfit({ page, perPage });
}

export async function getEarnedUserLevelBonusYieldInCurrentMonth(): Promise<AmountWithCurrencyObjectType> {
  const currentMonthlyProfit = await getMonthlyProfit({ page: 0, perPage: 1 });

  if (!currentMonthlyProfit.items[0]) {
    throw new Error('Unexpected error: no monthly profit for current month found.');
  }

  return currentMonthlyProfit.items[0].userLevelBonusYield;
}
